module.exports = __webpack_public_path__ + "img/108.4.199f4d0a.png";